import Component from "@glimmer/component";
import { action, computed } from "@ember/object";
import { service } from "@ember/service";
import DButton from "discourse/components/d-button";
import CircleManageAdvancedOwnershipModal from "../modal/manage-advanced-ownership";

export default class CircleManageOwnershipButton extends Component {
  @service modal;

  @computed(
    "args.mode",
    "args.model.owners.length",
    "args.model.member_group.user_count",
    "args.model.staff_group.user_count"
  )
  get disabled() {
    const model = this.args.model;

    if (!model) {
      return true;
    }

    if (this.args.mode === "add" || this.args.mode === "transfer") {
      return (
        model.owners.length >=
        Math.max(model.member_group.user_count, model.staff_group.user_count)
      );
    }

    if (this.args.mode === "remove") {
      return model.owners.length <= 1;
    }

    return true;
  }

  @action
  showManageOwnershipModal() {
    this.modal.show(CircleManageAdvancedOwnershipModal, {
      model: { circle: this.args.model, mode: this.args.mode },
    });
  }

  <template>
    <DButton
      @action={{this.showManageOwnershipModal}}
      @disabled={{this.disabled}}
      @icon={{this.icon}}
      @label="discourse_circles.circle.actions.ownership.{{@mode}}"
      class="circles-{{@mode}}-ownership-button btn-danger"
    />
  </template>
}
